import React from 'react';
import { SVGIcons } from '~/assets';

type Props = {
  iconName?: SVGIconKeys;
  iconProps?: SVGIconProps;
};

const Icon: React.FC<Props> = ({ iconName = 'heart', iconProps }) =>
  SVGIcons[iconName](iconProps);

export default Icon;
